import type { SidebarTreeNode } from '@/shared/constant/sidebar-tree/SidebarTreeNode';
import { ModelType } from '@tarslib/types/lib/common';
import React from 'react';
import { SidebarApi } from '../sidebar-api/SidebarApi';
import { SidebarDoc } from '../sidebar-doc/SidebarDoc';
import { SidebarFolder } from '../sidebar-folder/SidebarFolder';

export type SidebarTreeListProps = {
  list: SidebarTreeNode[];
  indentation: number;
  firstLevelSelectedApiFolderId?: number;
  className?: string;
  isHidden: boolean;
};

export const SidebarTreeList = React.memo(function SidebarTreeListComponent(
  props: SidebarTreeListProps,
) {
  const { list, className, indentation, firstLevelSelectedApiFolderId, isHidden } = props;

  if (!list.length) {
    return null;
  }

  return (
    <ul className={className}>
      {list.map((x, i) => {
        if (x.type === ModelType.Doc) {
          return <SidebarDoc value={x} key={x.key} isHidden={isHidden} />;
        } else if (x.type === ModelType.ApiFolder) {
          return (
            <SidebarFolder
              value={x}
              key={x.key}
              indentation={indentation}
              index={i}
              firstLevelSelectedApiFolderId={firstLevelSelectedApiFolderId}
              isHidden={isHidden}
            />
          );
        } else {
          return <SidebarApi value={x} key={x.key} isHidden={isHidden} />;
        }
      })}
    </ul>
  );
});
